import numeral from 'numeral';

const keys = [
    {
        key: 'impressions',
        label: 'Avg. Daily Impressions',
        icon: 'search',
        yAxisID: 'y3',
    },
    {
        key: 'ctr',
        label: 'Avg. CTR',
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'position',
        label: 'Position',
        format: '0.0',
        yAxisID: 'y2',
        info: 'The number of pages that generate Google Discover traffic that day',
        icon: 'pagev-view',
    },
    {
        key: 'clicks',
        label: 'Daily Clicks',
        icon: 'clicks',
    },
];

export const TAGS = [
    {
        label: 'All',
        id: 'all',
    },
    {
        label: 'Web',
        id: 'web',
    },
    {
        label: 'Discover',
        id: 'discover',
    },
    {
        label: 'Googlenews',
        id: 'googlenews',
    },
    {
        label: 'Image',
        id: 'image',
    },
    {
        label: 'News',
        id: 'news',
    },
    {
        label: 'Video',
        id: 'video',
    },
];

export default keys;
